import { render, staticRenderFns } from "./form_libros_new.vue?vue&type=template&id=0b21533f&scoped=true"
import script from "./form_libros_new.vue?vue&type=script&lang=js"
export * from "./form_libros_new.vue?vue&type=script&lang=js"
import style0 from "./form_libros_new.vue?vue&type=style&index=0&id=0b21533f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21533f",
  null
  
)

export default component.exports